import { Avatar } from "antd";
import Dashboard from "../assets/images/icon/data-governance.png";
import Team from "../assets/images/icon/group.png";
import deposit from "../assets/images/icon/wallet-in.png";
import Withdraw from "../assets/images/icon/wallet-out.png";
import transfer from "../assets/images/icon/transfer.png";
import verified from "../assets/images/icon/verified.png";
import profile from "../assets/images/icon/profile.png";
import bank from "../assets/images/icon/bank.png";
import settings from "../assets/images/icon/settings.png";
import cashier from "../assets/images/icon/cashier.png";
import googledocs from "../assets/images/icon/google-docs.png";
import report from "../assets/images/icon/data-analysis.png";
import invoices from "../assets/images/icon/invoice.png";
import purchasing from "../assets/images/icon/purchasing.png";
import ticket from "../assets/images/icon/ticket.png";
import iconKbiz from "../assets/images/app-icon.png";

export const FormatIconMenu = (icon) => {
  if (!icon || !icon.icon) {
    return null;
  }
  let iconToRender = icon;
  if (icon.icon === "DashboardOutlined") {
    // iconToRender.icon = <DashboardOutlined />;
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={Dashboard} alt="avatar" />}
      />
    );
  }
  if (icon.icon === "TeamOutlined") {
    iconToRender.icon = (
      <Avatar shape="square" size={24} src={<img src={Team} alt="avatar" />} />
    );
    // iconToRender.icon = <TeamOutlined />;
  }
  if (icon.icon === "PlusOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={deposit} alt="avatar" />}
      />
    );
    // iconToRender.icon = <PlusOutlined />;
  }
  if (icon.icon === "MinusOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={Withdraw} alt="avatar" />}
      />
    );
    // iconToRender.icon = <MinusOutlined />;
  }
  if (icon.icon === "SwapOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={transfer} alt="avatar" />}
      />
    );
    // iconToRender.icon = <SwapOutlined />;
  }
  if (icon.icon === "HistoryOutlined") {
    iconToRender.icon = (
      <Avatar shape="square" size={24} src={<img src={bank} alt="avatar" />} />
    );
    // iconToRender.icon = <HistoryOutlined />;
  }
  if (icon.icon === "BankOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={cashier} alt="avatar" />}
      />
    );
    // iconToRender.icon = <BankOutlined />;
  }
  if (icon.icon === "UserOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={profile} alt="avatar" />}
      />
    );
    // iconToRender.icon = <UserOutlined />;
  }
  if (icon.icon === "InvoicesOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={invoices} alt="avatar" />}
      />
    );
    // iconToRender.icon = <UserOutlined />;
  }
  if (icon.icon === "SettingOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={settings} alt="avatar" />}
      />
    );
    // iconToRender.icon = <SettingOutlined />;
  }
  if (icon.icon === "CheckTheSlip") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={verified} alt="avatar" />}
      />
    );
    // iconToRender.icon = <FileDoneOutlined />;
  }
  if (icon.icon === "ReportOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={report} alt="avatar" />}
      />
    );
    // iconToRender.icon = <FileDoneOutlined />;
  }
  if (icon.icon === "FileTextOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={googledocs} alt="avatar" />}
      />
    );
    // iconToRender.icon = <FileTextOutlined />;
  }
  if (icon.icon === "buyCreditOutlined") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={purchasing} alt="avatar" />}
      />
    );
    // iconToRender.icon = <FileTextOutlined />;
  }

  if (icon.icon === "SupportTicket") {
    iconToRender.icon = (
      <Avatar
        shape="square"
        size={24}
        src={<img src={ticket} alt="avatar" />}
      />
    );
    // iconToRender.icon = <FileTextOutlined />;
  }
  return iconToRender;
};

export const URLIconKbiz = {
  url: iconKbiz,
}
